<template> </template>

<script>
import BaseSlide from './BaseSlide';

export default {
	name: 'TeamPositionsSlide',
	mixins: [BaseSlide],
};
</script>

<style></style>
